import React from 'react';

import { breakpoints } from '../../scripts/variables';

const WithWindowSizes = (Component) => {
  return class extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        windowWidth: null,
        pageBreakpoint: null
      };

      this.updateTimeout = null;
    }

    componentDidMount() {
      this.setValues();

      window.addEventListener('resize', this.onWindowResize.bind(this));
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.onWindowResize);
    }

    onWindowResize() {
      // Обновления стейта происходит однократно через 500мс после окончания изменения размера экрана
      clearTimeout(this.updateTimeout);
      this.updateTimeout = setTimeout(() => {
        this.setValues();
      }, 500);
    }

    setValues() {
      let currentBreakpoint = null;
      if (window.innerWidth <= breakpoints.largeMobile) {
        currentBreakpoint = 'mobile';
      } else if (window.innerWidth <= breakpoints.tabletLandscape) {
        currentBreakpoint = 'tablet';
      } else {
        currentBreakpoint = 'desktop';
      }

      this.setState({
        windowWidth: window.innerWidth,
        pageBreakpoint: currentBreakpoint
      });
    }

    render() {
      return <Component {...this.props} {...this.state} />;
    }
  };
};

export default WithWindowSizes;
